import { createContext, useState } from "react";

export const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
  const [message, setMessage] = useState(null);
  const [type, setType] = useState("success");

  const showMessage = (msg, msgType = "success") => {
    setMessage(msg);
    setType(msgType);

    if (msg) {
      setTimeout(() => {
        setMessage(null);
      }, 5000);
    }
  };

  return (
    <MessageContext.Provider value={{ message, type, showMessage }}>
      {children}
    </MessageContext.Provider>
  );
};
